
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserPlus } from "lucide-react";

interface ReferredBenefitsCardProps {
  formData: {
    referred_discount_type: string;
    referred_discount_value: string;
    referred_min_purchase: string;
  };
  updateFormField: (field: string, value: string) => void;
  isDisabled: boolean;
}

export const ReferredBenefitsCard = ({ formData, updateFormField, isDisabled }: ReferredBenefitsCardProps) => {
  return (
    <Card className="border-blue-200 bg-blue-50/30">
      <CardHeader className="pb-4">
        <div className="flex items-center gap-2">
          <UserPlus className="h-5 w-5 text-blue-600" />
          <div>
            <CardTitle className="text-lg text-blue-900">Benefícios para o Indicado</CardTitle>
            <CardDescription className="text-blue-700">
              Configure o desconto que o indicado receberá na primeira compra
            </CardDescription>
          </div>
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="referred_discount_type">Tipo de Desconto</Label>
          <Select 
            value={formData.referred_discount_type} 
            onValueChange={(value) => updateFormField('referred_discount_type', value)}
            disabled={isDisabled}
          >
            <SelectTrigger>
              <SelectValue placeholder="Selecione o tipo" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="percentage">Percentual (%)</SelectItem>
              <SelectItem value="fixed_value">Valor Fixo (R$)</SelectItem>
            </SelectContent>
          </Select>
          <p className="text-xs text-blue-600">
            Percentual ou valor fixo
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="referred_discount_value">
            Valor do Desconto {formData.referred_discount_type === 'percentage' ? '(%)' : '(R$)'}
          </Label>
          <Input 
            id="referred_discount_value" 
            type="number" 
            step="0.01"
            min="0"
            max={formData.referred_discount_type === 'percentage' ? "100" : undefined}
            placeholder={formData.referred_discount_type === 'percentage' ? "10.00" : "15.00"} 
            value={formData.referred_discount_value}
            onChange={(e) => updateFormField('referred_discount_value', e.target.value)}
            disabled={isDisabled}
          />
          <p className="text-xs text-blue-600">
            Desconto aplicado
          </p>
        </div>

        <div className="space-y-2">
          <Label htmlFor="referred_min_purchase">Valor Mínimo de Compra (R$)</Label>
          <Input 
            id="referred_min_purchase" 
            type="number" 
            step="0.01"
            min="0"
            placeholder="50.00" 
            value={formData.referred_min_purchase}
            onChange={(e) => updateFormField('referred_min_purchase', e.target.value)}
            disabled={isDisabled}
          />
          <p className="text-xs text-blue-600">
            Compra mínima para desconto
          </p>
        </div>
      </CardContent>
    </Card>
  );
};
